import { motion } from "framer-motion";
import { BOOK } from "../lib/content";

export const Reviews = () => (
  <section id="frases" className="py-24 sm:py-32 lg:py-40 bg-[#0d0d13] border-y border-white/5" data-testid="quotes-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.9 }}
        className="mb-20 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6"
      >
        <div>
          <span className="label-eyebrow">Del libro</span>
          <h2 className="mt-6 font-display font-semibold uppercase text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight">
            Frases que marcan <span className="text-gold">el partido</span>
          </h2>
        </div>
        <span className="text-xs uppercase tracking-[0.25em] text-[#6E6C67]">Directo de sus páginas</span>
      </motion.div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {BOOK.quotes.map((q, i) => (
          <motion.figure
            key={q.source}
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, delay: i * 0.15 }}
            className="card-glow border border-white/8 bg-[#181822]/50 p-10 flex flex-col"
            data-testid={`quote-card-${i}`}
          >
            <span className="font-serif-book text-6xl leading-none text-[#C5A059]/60 select-none">“</span>
            <blockquote className="mt-2 font-serif-book italic text-xl sm:text-2xl leading-snug text-[#E8E4DB] flex-1">
              {q.text}
            </blockquote>
            <figcaption className="mt-8 pt-6 border-t border-white/5 text-xs uppercase tracking-[0.25em] text-[#C5A059]">
              {q.source}
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
